import "./index.scss";
import PostShareAndInfo from "../PostShareAndInfo";
import React from "react";

interface Props {
  date?: string;
  location?: string;
}

export default function PostFooter({ date, location }: Props) {
  return (
    <div className="PostFooter container-fluid">
      <div className="row justify-content-center">
        <div className="col-12 col-md-8 mb--xs">
          <div className="row">
            <div className="col-12">
              <div className="PostFooter__border pt--xs" />
            </div>
          </div>
          <PostShareAndInfo date={date} location={location} />
        </div>
      </div>
    </div>
  );
}
